/* eslint-disable no-restricted-syntax */
/**
 * Markup stroke style definitions. Each entry in the array contains the following properties:
 *
 *  - key {String}: Unique key identifying the style. Can be used to look up the style in STROKE_STYLE_MAP.
 *  - label {String}: Style name (title case).
 *  - style: {number[]}: Style value used for rendering.
 */

export interface StrokeStyle {
  key: string
  label: string
  style: number[]
}

export const STROKE_STYLES: StrokeStyle[] = [
  {
    key: 'solid',
    label: 'Solid',
    style: [0],
  },
  {
    key: 'dash',
    label: 'Dash',
    style: [15, 10],
  },
  {
    key: 'dot',
    label: 'Dot',
    style: [0.1, 10],
  },
]

/**
 * Maps style keys to the style definition object.
 * @see STROKE_STYLES
 */
export const STROKE_STYLE_MAP = new Map<string, StrokeStyle>([
  ...STROKE_STYLES.map((style) => [style.key, style] as [string, StrokeStyle]),
])

/**
 * Markup stroke weight definitions. Each entry in the array contains the following properties:
 *
 *  - key {String}: Unique key identifying the weight. Can be used to look up the style in STROKE_WEIGHT_MAP.
 *  - label {String}: Weight name (title case).
 *  - weight: {number}: Weight value used for rendering.
 */

export interface StrokeWeight {
  key: string
  label: string
  weight: number
}

export const STROKE_WEIGHTS: StrokeWeight[] = [
  {
    key: 'thin',
    label: 'Thin',
    weight: 2,
  },
  {
    key: 'normal',
    label: 'Medium',
    weight: 4,
  },
  {
    key: 'thick',
    label: 'Thick',
    weight: 6,
  },
]

/**
 * Maps weight keys to the weight definition object.
 * @see STROKE_WEIGHTS
 */
export const STROKE_WEIGHT_MAP = new Map<string, StrokeWeight>([
  ...STROKE_WEIGHTS.map(
    (weight) => [weight.key, weight] as [string, StrokeWeight]
  ),
])
